<template>
  <div class="flex flex-col gap-4">
    <TaskGroupSection
      v-for="group in groups"
      :key="groupCollapseKey(group.key)"
      :group="group"
      :show-header="showGroupHeaders"
      :selection-state="groupSelectionState(group)"
      @toggle-select-group="selection.toggleGroup(selectableIdsOf(group))"
      @toggle-collapse="$emit('toggle-collapse', group)"
      @load-more="$emit('load-more', group)"
    >
      <div class="grid grid-cols-1 gap-2 md:grid-cols-2 xl:grid-cols-3">
        <TaskDossierCard
          v-for="task in group.task_dossiers"
          :key="task.id"
          :task="task"
          :is-item-task="true"
          :status-click-cycle="statusClickCycle"
          :display-fields="settings.fields"
          :selectable="selection !== null"
          :selected="selection?.isSelected(task.id) ?? false"
          :hide-select-on-narrow="true"
          @toggle-select="selection.toggle(task.id)"
          @refresh-list="$emit('refresh-list')"
          @task-deleted="$emit('task-deleted', $event)"
          @task-status-updated="$emit('task-status-updated', $event)"
        />
      </div>
      <template #loading-more>
        <div class="grid grid-cols-1 gap-2 md:grid-cols-2 xl:grid-cols-3">
          <BaseSkeleton :count="3">
            <TaskCardSkeleton />
          </BaseSkeleton>
        </div>
      </template>
    </TaskGroupSection>
  </div>
</template>

<script>
import BaseSkeleton from '@c/BaseSkeleton.vue'
import TaskGroupSection from '../components/TaskGroupSection.vue'
import TaskCardSkeleton from '../components/TaskCardSkeleton.vue'
import { groupCollapseKey } from '../utils/taskDashboardSettings'
import TaskDossierCard from '@/views/dossier/form/subpages/taskDossier/components/taskDossierList/components/TaskDossierCard.vue'

export default {
  name: 'TaskCardsView',
  components: {
    BaseSkeleton,
    TaskGroupSection,
    TaskCardSkeleton,
    TaskDossierCard
  },
  props: {
    selection: { type: Object, required: false, default: null },
    groups: { type: Array, required: true },
    settings: { type: Object, required: true },
    showGroupHeaders: { type: Boolean, required: true },
    statusClickCycle: { type: Boolean, required: false, default: true },
    /** Unused here: declared so the container prop shared by every view does not fall through as an attribute. */
    statusCounts: { type: Object, required: false, default: () => ({}) }
  },
  emits: [
    'toggle-collapse',
    'load-more',
    'task-status-updated',
    'task-deleted',
    'refresh-list'
  ],
  methods: {
    groupCollapseKey,
    /** null hides the select-all: nothing to select while the group is not loaded. */
    groupSelectionState(group) {
      const ids = this.selectableIdsOf(group)
      return this.selection && ids.length > 0
        ? this.selection.groupState(ids)
        : null
    },
    /** The tasks a group's select-all covers: those loaded on screen. */
    selectableIdsOf(group) {
      return group.task_dossiers.map((task) => task.id)
    }
  }
}
</script>
